import { EventDispatcher } from './utils';

type DisposerFn = () => void;
const disposeListener = (dispose: DisposerFn) => dispose();

export class UxplComponent<EventMap> {
  protected eventDispatcher: EventDispatcher<EventMap>;
  protected eventDisposers: Array<DisposerFn>;

  constructor() {
    this.eventDispatcher = new EventDispatcher<EventMap>();
    this.eventDisposers = [];
  }

  addEventListener<K extends keyof EventMap>(
    eventName: K,
    listener: (event: EventMap[K]) => void
  ): void {
    this.eventDispatcher.addEventListener(eventName, listener);
  }

  removeEventListener<K extends keyof EventMap>(
    eventName: K,
    listener: (event: EventMap[K]) => void
  ): void {
    this.eventDispatcher.removeEventListener(eventName, listener);
  }
  destroy(): void {
    this.eventDispatcher.clearAll();
    this.eventDisposers.forEach(disposeListener);
  }
}
